import { Outlet } from "react-router-dom";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Breadcrumbs from "../../components/Breadcrumbs/Breadcrumbs";


export default function Layout() {
    return (
        <div>
            <Header />
            <main id='main-content'>
                <Breadcrumbs />
                <Outlet />
            </main>
            <Footer />
        </div>
    )
}